import axios from 'axios';

// 实例化axios对象，设置默认请求配置
const api = axios.create();
api.defaults.timeout = 10000;
api.defaults.baseURL = '';
api.defaults.headers = {
    'Content-Type': 'application/json'
};

// 设置拦截器
api.interceptors.request.use(function (config) {
    console.log('api_request_config：', config);

    return config;
}, function (error) {
    return Promise.reject(error);
});
api.interceptors.response.use(function (response) {
    console.log('api_success：', response);
    return Promise.resolve(response.data, response);
}, function (error) {
    /* 判断error的status代码，并将对应的信息告知用户 */
    let msg = '';
    let res = error.response;
    console.log('api_error：', res);
    if (res.status) {
        switch (res.status) {
            case 400:
            case 401:
            case 403:
            case 404:
                msg = '请求失败';
                break;
            case 408:
                msg = '请求超时';
                break;
            case 500:
            case 501:
            case 502:
            case 503:
            case 504:
            case 505:
                msg = '服务端错误';
                break;
            default:
                msg = '网络连接出错'
        }
        msg += '（' +res.status+ '）';
    } else {
        msg = '连接服务器失败,请退出重试!'
    }
    return Promise.reject({msg:msg}, res);
});

export default api